import {Datagrid, List, TextField, DateField} from "react-admin";
import * as React from "react";

export const ReportTemplatesList = (props) => {

    return (
        <List
            {...props}
        >
            <Datagrid rowClick="edit">>
                <TextField source="id"/>
                <TextField source="category"/>
                <DateField source="createdate" showTime={true}/>
                <DateField source="lastupdate" showTime={true}/>
                <TextField source="createdby"/>
                <TextField source="updatedby"/>

            </Datagrid>
        </List>
    );

};

